<div class="card">
  <h5 class="page-title">Hub Network</h5>

  <div *ngIf="featureDisabled" class="feature-disabled">
    TinyAll Delivery Network is not enabled on this environment
    (set <code>TINYALL_DELIVERY_NETWORK_ENABLED=true</code> on the backend).
  </div>

  <div *ngIf="!featureDisabled" class="workflow-banner">
    <strong>Hub network access control</strong>
    <p>
      Use this page to control which hubs can use TinyAll Delivery Network dispatch and V2 broadcast.
      Disabling or pausing a hub blocks network broadcast/assignment.
      V2 disabled hides the V2 broadcast panel but may allow legacy paired behavior depending on the hub/order state.
    </p>
  </div>

  <div *ngIf="!featureDisabled" class="toolbar">
    <label>
      Search:
      <input type="text" [(ngModel)]="search" placeholder="Hub name, ID, email" (keyup.enter)="loadData()" />
    </label>
    <label>
      Enabled:
      <select [(ngModel)]="enabledFilter" (change)="loadData()">
        <option value="">All</option>
        <option value="true">Enabled</option>
        <option value="false">Disabled</option>
      </select>
    </label>
    <label>
      Paused:
      <select [(ngModel)]="pausedFilter" (change)="loadData()">
        <option value="">All</option>
        <option value="true">Paused</option>
        <option value="false">Active</option>
      </select>
    </label>
    <label>
      V2:
      <select [(ngModel)]="v2Filter" (change)="loadData()">
        <option value="">All</option>
        <option value="true">V2 on</option>
        <option value="false">V2 off</option>
      </select>
    </label>
    <button pButton type="button" icon="pi pi-refresh" label="Refresh"
            class="p-button-sm p-button-secondary" (click)="loadData()"></button>
  </div>

  <p-table
    *ngIf="!featureDisabled"
    [value]="data"
    dataKey="hubId"
    [rows]="15"
    [paginator]="true"
    [rowsPerPageOptions]="[15, 30, 60]"
    [loading]="isLoading"
    styleClass="p-datatable-customers p-datatable-gridlines"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Hub</th>
        <th>Owner</th>
        <th>Network</th>
        <th>V2</th>
        <th>Last updated</th>
        <th>Last admin note</th>
        <th class="actions-col">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>
          <div class="hub-cell">
            <strong>{{ row.hubName || '—' }}</strong>
            <span class="hub-id">
              {{ row.hubId }}
              <button pButton type="button" icon="pi pi-copy" class="p-button-text p-button-sm"
                      (click)="copyHubId(row.hubId)" title="Copy hub ID"></button>
            </span>
          </div>
        </td>
        <td>
          <div>{{ row.ownerName || '—' }}</div>
          <div class="muted">{{ row.ownerEmail || '' }}</div>
        </td>
        <td>
          <span class="status-chip" [ngClass]="networkStatusClass(row)">{{ networkStatusLabel(row) }}</span>
        </td>
        <td>
          <span class="status-chip" [ngClass]="v2StatusClass(row)">
            {{ row.v2Enabled ? 'V2 enabled' : 'V2 disabled' }}
          </span>
        </td>
        <td>{{ formatDate(row.updatedAt) }}</td>
        <td>
          <div *ngIf="row.lastAdminReason">{{ row.lastAdminReason }}</div>
          <div class="muted" *ngIf="row.lastAdminUpdatedBy">by {{ row.lastAdminUpdatedBy }}</div>
          <span *ngIf="!row.lastAdminReason">—</span>
        </td>
        <td class="actions-col">
          <button *ngIf="row.enabled" pButton type="button" label="Disable"
                  class="p-button-sm p-button-danger p-button-outlined"
                  (click)="openAction(row, 'disable-network')"></button>
          <button *ngIf="!row.enabled" pButton type="button" label="Enable"
                  class="p-button-sm p-button-success p-button-outlined"
                  (click)="openAction(row, 'enable-network')"></button>
          <button *ngIf="row.enabled && !row.paused" pButton type="button" label="Pause"
                  class="p-button-sm p-button-warning p-button-outlined"
                  (click)="openAction(row, 'pause')"></button>
          <button *ngIf="row.paused" pButton type="button" label="Unpause"
                  class="p-button-sm p-button-outlined"
                  (click)="openAction(row, 'unpause')"></button>
          <button *ngIf="row.enabled && !row.v2Enabled" pButton type="button" label="Enable V2"
                  class="p-button-sm p-button-outlined"
                  (click)="openAction(row, 'enable-v2')"></button>
          <button *ngIf="row.v2Enabled" pButton type="button" label="Disable V2"
                  class="p-button-sm p-button-outlined"
                  (click)="openAction(row, 'disable-v2')"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No hub enrollments found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [(visible)]="actionDialogVisible"
  [header]="pendingAction?.title || 'Confirm'"
  [modal]="true"
  [style]="{ width: '480px' }"
  [closable]="!isSaving"
>
  <p *ngIf="pendingAction">{{ pendingAction.description }}</p>
  <div class="reason-field">
    <label for="hubActionReason"><strong>Reason (required)</strong></label>
    <textarea id="hubActionReason" pInputTextarea rows="3" [(ngModel)]="actionReason"
              [disabled]="isSaving" placeholder="Why is this change being made?"></textarea>
    <div class="reason-examples">
      Examples:
      <button *ngFor="let ex of reasonExamples" type="button" class="example-chip"
              (click)="actionReason = ex">{{ ex }}</button>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text"
            [disabled]="isSaving" (click)="actionDialogVisible = false"></button>
    <button pButton type="button" label="Confirm" [loading]="isSaving"
            (click)="confirmAction()"></button>
  </ng-template>
</p-dialog>
